"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.GroupInformationWidget = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _utils = require("./utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _World = _interopRequireDefault(require("@insided/destination/icons/World"));

var _ClockDark = _interopRequireDefault(require("@insided/shared/icons/ClockDark"));

var _Members = _interopRequireDefault(require("@insided/destination/icons/Members"));

var _Threads = _interopRequireDefault(require("@insided/destination/icons/Threads"));

var _ReplyMeta = _interopRequireDefault(require("@insided/destination/icons/ReplyMeta"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _common = require("@insided/shared/utils/common");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DESCRIPTION_LENGTH_DEFAULT = 140;
var cssAnchorName = 'group-details-information-widget';
exports.cssAnchorName = cssAnchorName;

var getGroupCreationDate = function getGroupCreationDate(date) {
  var _navigator$language;

  var defaultLocale = 'en-US';
  var userLang = typeof window === 'undefined' ? defaultLocale : (_navigator$language = navigator.language) !== null && _navigator$language !== void 0 ? _navigator$language : defaultLocale;
  var creationDate = new Date(date * 1000);
  var dateFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  };
  return creationDate.toLocaleDateString(userLang, dateFormatOptions);
};

var GroupInformationWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupInformationWidget, _Component);

  var _super = _createSuper(GroupInformationWidget);

  function GroupInformationWidget() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupInformationWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      needShowMore: false,
      showMore: false,
      description: _this.props.group.description
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onShowMoreSwitch", function () {
      _this.setState(function (state) {
        return {
          showMore: !state.showMore
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      var description = _this.state.description;

      var textContent = _htmlParser.default.stripHtml(description);

      _this.setState({
        needShowMore: textContent.length > DESCRIPTION_LENGTH_DEFAULT
      });
    });
    return _this;
  }

  (0, _createClass2.default)(GroupInformationWidget, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          needShowMore = _this$state.needShowMore,
          showMore = _this$state.showMore,
          description = _this$state.description;
      var group = this.props.group;
      return (0, _preact.h)("div", {
        className: "qa-div-sidebar-group-information",
        "data-bounded-context": "Groups",
        "data-entity": "group-details-information-widget"
      }, (0, _preact.h)("div", {
        className: "group-detail-info"
      }, (0, _preact.h)("div", {
        className: "widget group-content-container-information"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.information.about"
      })), (0, _preact.h)("div", {
        className: "group-content-container-information__description"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('group-content-container-information__description__text', {
          'is-collapsed': needShowMore && !showMore
        }),
        dangerouslySetInnerHTML: {
          __html: description
        }
      }), (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('group-content-container-information__more-btn', {
          'is-visible': needShowMore && !showMore
        }),
        title: (0, _preact.h)(_phrase.default, {
          p: "groups.show.more"
        }),
        onClick: this.onShowMoreSwitch,
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('group-content-container-information__less-btn', {
          'is-visible': needShowMore && showMore
        }),
        title: (0, _preact.h)(_phrase.default, {
          p: "quick.links.show.less"
        }),
        onClick: this.onShowMoreSwitch,
        size: "medium"
      })), (0, _preact.h)("div", {
        className: "group-content-container-information__main-info"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key"
      }, (0, _preact.h)(_World.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key__label"
      }, group.visibility === _utils.GroupVisibility.Public ? (0, _preact.h)(_phrase.default, {
        p: "groups.information.public.group"
      }) : null, group.visibility === _utils.GroupVisibility.Private ? (0, _preact.h)(_phrase.default, {
        p: "groups.information.private.group"
      }) : null, group.visibility === _utils.GroupVisibility.Hidden ? (0, _preact.h)(_phrase.default, {
        p: "groups.information.hidden.group"
      }) : null))), group.creationDate ? (0, _preact.h)("div", {
        className: "group-content-container-information__info-field"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key"
      }, (0, _preact.h)(_ClockDark.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key__label"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.information.created.on"
      }), " ", getGroupCreationDate(group.creationDate)))) : null), (0, _preact.h)("div", {
        className: "group-content-container-information__additional-info"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key"
      }, (0, _preact.h)(_Members.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key__label"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.group.members"
      }))), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__value"
      }, group.membersCount.members + group.membersCount.moderators)), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key"
      }, (0, _preact.h)(_Threads.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key__label"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.information.threads"
      }))), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__value"
      }, group.category.counters.topics)), group.category.lastPostDate ? (0, _preact.h)("div", {
        className: "group-content-container-information__info-field"
      }, (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key"
      }, (0, _preact.h)(_ReplyMeta.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__key__label"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.information.last.post"
      }))), (0, _preact.h)("div", {
        className: "group-content-container-information__info-field__value"
      }, _common.common.relativeDate(group.category.lastPostDate * 1000))) : null))));
    }
  }]);
  return GroupInformationWidget;
}(_preact.Component);

exports.GroupInformationWidget = GroupInformationWidget;
var _default = GroupInformationWidget;
exports.default = _default;